import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import { pdf, Page, Text, Document, StyleSheet } from '@react-pdf/renderer';
import Modal from 'react-modal';
import InvoicePDF from '../Sales/InvoiceSales';

const DetailPurchases = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);

    const [detailData, setDetailData] = useState(null);
    const [itemData, setItemData] = useState([]);
    const [paymentData, setPaymentData] = useState([]);
    const [actions, setActions] = useState([
        { value: 'edit', label: 'Ubah' },
        { value: 'make-payment', label: 'Lakukan Pembayaran' },
        { value: 'invoice', label: 'Cetak Invoice' },
    ]);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PURCHASE = "api/erpppsu/purchases";

    const fetchData = async (url) => {
        try {
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_PURCHASE}/detail?id=${id}`).then((data) => {
                setDetailData(data)
            });

            fetchData(`${BASE_URL}${PATH_PURCHASE}/items?id=${id}`).then((data) => {
                setItemData(data)
            });

            fetchData(`${BASE_URL}${PATH_PURCHASE}/payment?id=${id}`).then((data) => {
                setPaymentData(data)
            });
        }
    }, [id]);

    useEffect(() => {
        if (detailData) {
            if (detailData.status == 'PAID') {
                setActions([
                    { value: 'edit', label: 'Ubah' },
                    { value: 'invoice', label: 'Cetak Invoice' },
                ])
            } else if (detailData.status == 'CLOSED') {
                setActions([
                    { value: 'invoice', label: 'Cetak Invoice' },
                ])
            }
        }
    }, [detailData]);

    const handlePreview = async () => {
        const blob = await pdf(<InvoicePDF detailData={detailData} itemData={itemData} logoUrl={'http://localhost/hijrah-backend/upload/logo/1734138205_logo.png'} />).toBlob();
        const url = URL.createObjectURL(blob);
        setPdfPreviewUrl(url);
        setIsModalOpen(true);
    };

    return (
        <div className="p-6 bg-gray-50 font-sans">
            <h1 className="text-2xl font-bold mb-6">Faktur</h1>

            {/* Customer Details */}
            <div className="mb-4">
                <div className="flex justify-between">
                    <div>
                        <p className="font-semibold">Supplier:</p>
                        <p>{detailData?.supplier_name}</p>
                    </div>
                    <div>
                        <p className="font-semibold">Email:</p>
                        <p>{detailData?.supplier_email}</p>
                    </div>
                </div>
            </div>

            {/* Billing Details */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div>
                    <p className="font-semibold">Alamat Penagihan:</p>
                    <p>{detailData?.address}</p>
                </div>
                <div>
                    <p className="font-semibold">Tgl. Transaksi:</p>
                    <p>{detailData?.date}</p>
                    <p className="font-semibold mt-2">Tgl. Jatuh Tempo:</p>
                    <p>{detailData?.due_date}</p>
                </div>
                <div>
                    <p className="font-semibold">No Transaksi:</p>
                    <p>{detailData?.no_transaction}</p>
                    <p className="font-semibold mt-2">Tag:</p>
                    <p>{detailData?.tags}</p>
                </div>
            </div>

            <hr className="my-4" />

            {/* Products Table */}
            <table className="w-full text-left border-collapse">
                <thead>
                    <tr className="bg-gray-100 border-b">
                        <th className="p-2">Produk</th>
                        <th className="p-2">Deskripsi</th>
                        <th className="p-2 text-right">Kuantitas</th>
                        <th className="p-2 text-right">Unit</th>
                        <th className="p-2 text-right">Harga Satuan</th>
                        <th className="p-2 text-right">Diskon</th>
                        <th className="p-2 text-right">Pajak</th>
                        <th className="p-2 text-right">Jumlah</th>
                    </tr>
                </thead>
                <tbody>
                    {itemData?.map((product, index) => (
                        <tr
                            key={index}
                            className="border-b hover:bg-gray-50 transition-colors"
                        >
                            <td className="p-2">{product?.product_name}</td>
                            <td className="p-2">{product?.description}</td>
                            <td className="p-2 text-right">{product?.quantity}</td>
                            <td className="p-2 text-right">{product?.unit}</td>
                            <td className="p-2 text-right">
                                Rp {parseFloat(product?.unit_price).toLocaleString("id-ID")}
                            </td>
                            <td className="p-2 text-right">{product?.discount}%</td>
                            <td className="p-2 text-right">{product?.tax_name}</td>
                            <td className="p-2 text-right">
                                Rp {parseFloat(product?.amount).toLocaleString("id-ID")}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Summary Section */}
            <div className="flex flex-col items-end mt-6">
                <p className="text-right">
                    <span className="font-semibold">Subtotal:</span> Rp{" "}
                    {parseFloat(detailData?.subtotal_amount).toLocaleString("id-ID")}
                </p>
                <p className="text-right">
                    <span className="font-semibold">Pajak:</span> Rp{" "}
                    {parseFloat(detailData?.tax_amount).toLocaleString("id-ID")}
                </p>
                <h3 className="text-right text-lg font-bold mt-2">
                    Total: Rp {parseFloat(detailData?.amount).toLocaleString("id-ID")}
                </h3>
                <h3 className="text-right text-lg font-bold text-blue-600 mt-2">
                    Sisa Tagihan: Rp {parseFloat(detailData?.outstanding_amount).toLocaleString("id-ID")}
                </h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 my-6">
                <div>
                    <p>
                        <span className="font-semibold">Pesan:</span> {detailData?.notes}
                    </p>
                    <p>
                        <span className="font-semibold">Memo:</span> {detailData?.memo}
                    </p>
                </div>

                <table className="text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-100 border-b">
                            <th className="p-2">Tanggal</th>
                            <th className="p-2">Nomor</th>
                            <th className="p-2">Pembayaran Dari</th>
                            <th className="p-2">Status Pembayaran</th>
                            <th className="p-2 text-right">Jumlah (Rp)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paymentData?.map((payment, index) => (
                            <tr
                                key={index}
                                className="border-b hover:bg-gray-50 transition-colors"
                            >
                                <td className="p-2">{payment?.date}</td>
                                <td className="p-2">{payment?.no_transaction}</td>
                                <td className="p-2">{payment?.cash_name}</td>
                                <td className="p-2 text-right">
                                    {payment?.notes}
                                </td>
                                <td className="p-2 text-right">
                                    Rp {parseFloat(payment?.amount).toLocaleString("id-ID")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Footer */}
            <footer className="mt-6 text-sm text-gray-500">
                Terakhir diubah oleh {detailData?.updated_by} pada{" "}
                {detailData?.updated_at}.
            </footer>

            <div className='flex flex-row mt-6'>
                <ButtonOptionGroup
                    position='popup-position'
                    label={"Tindakan"}
                    options={actions}
                    onChange={(value) => {
                        if (value == 'invoice') {
                            handlePreview();
                        } else if (value == 'make-payment') {
                            navigate(`/activity-erpppsu/purchases/${value}/${detailData.supplier_id}`);
                        } else {
                            navigate(`/activity-erpppsu/purchases/${value}/${detailData.id}`);
                        }
                    }}
                />
            </div>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                contentLabel="PDF Preview Modal"
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        height: '80%',
                    },
                    overlay: { zIndex: 1000, backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                }}
            >
                <div className="modal-header">
                    <h4>Invoice Preview</h4>
                    <button className="close-button" onClick={() => setIsModalOpen(false)}>
                        &times;
                    </button>
                </div>
                <iframe
                    src={pdfPreviewUrl}
                    title="PDF Preview"
                    width="100%"
                    height="100%"
                    className="border border-gray-300 rounded"
                ></iframe>
                <div className="text-center mt-4">
                    <a
                        href={pdfPreviewUrl}
                        download="Invoice.pdf"
                        className="px-4 py-2 bg-green-500 text-white rounded"
                    >
                        Download PDF
                    </a>
                </div>
            </Modal>
        </div>
    );
}

export default DetailPurchases;
